export const mobileAssistantTestWidths = [320, 375, 390, 430] as const;

const practiceRoutePattern = /^\/study\/(massage-ce-12|cosmetology-ce-4|mblex-prep|new-york-prep|hawaii-prep|texas-prep|texas-cosmetology-prep|texas-esthetician-prep|texas-barber-prep)\/practice$/;

export function isPracticeRoutePath(pathname: string) {
  return pathname === "/free-mblex" || practiceRoutePattern.test(pathname);
}

export function shouldRenderPracticeTutor(started: boolean, hasQuestion: boolean) {
  return started && hasQuestion;
}
